import _slicedToArray from "/builds/everlywell/apps/www/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { __rest } from "tslib";
import React, { useState } from "react";
import { useTransition } from "react-spring";
import { LeftCaret, RightCaret } from "../../Icons";
import { Slide } from "../Slide";
import { TransitionContainer } from "../TransitionContainer/styles";
import * as S from "./styles";
export function getPreviousIndex(e, t) {
  return 0 === e ? t - 1 : e - 1;
}
export function getNextIndex(e, t) {
  return e + 1 === t ? 0 : e + 1;
}

var LeftControl = function LeftControl(_ref) {
  var e = _ref.onClick;
  return React.createElement(S.LeftControl, {
    "data-testid": "left-slider-control",
    "aria-label": "Previous Slide",
    onClick: function onClick() {
      return e();
    }
  }, React.createElement(S.ControlIcon, {
    as: LeftCaret
  }));
},
    RightControl = function RightControl(_ref2) {
  var e = _ref2.onClick;
  return React.createElement(S.RightControl, {
    "data-testid": "right-slider-control",
    "aria-label": "Next Slide",
    onClick: function onClick() {
      return e();
    }
  }, React.createElement(S.ControlIcon, {
    as: RightCaret
  }));
},
    customConfig = {
  mass: 1,
  tension: 120,
  friction: 50,
  precision: 1e-4
};

export function SliderContainer(e) {
  var t = e.title,
      r = e.slideData,
      n = __rest(e, ["title", "slideData"]);

  var a = r.length,
      _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      i = _useState2[0],
      o = _useState2[1],
      _useState3 = useState("right"),
      _useState4 = _slicedToArray(_useState3, 2),
      l = _useState4[0],
      s = _useState4[1],
      c = useTransition(i, {
    config: Object.assign(Object.assign({}, customConfig), {
      friction: .8 * customConfig.friction
    }),
    from: {
      transform: "right" === l ? "translate3d(-125%, 0, 0)" : "translate3d(125%, 0, 0)"
    },
    enter: {
      transform: "translate3d(0%, 0, 0)",
      delay: 200
    },
    leave: {
      transform: "right" === l ? "translate3d(125%, 0, 0)" : "translate3d(-125%, 0, 0)",
      position: "absolute"
    }
  }),
      m = useTransition(i, {
    config: Object.assign(Object.assign({}, customConfig), {
      friction: .6 * customConfig.friction
    }),
    from: {
      transform: "right" === l ? "translate3d(-125%, 0, 0)" : "translate3d(125%, 0, 0)"
    },
    enter: {
      transform: "translate3d(0%, 0, 0)",
      delay: 200
    },
    leave: {
      transform: "right" === l ? "translate3d(125%, 0, 0)" : "translate3d(-125%, 0, 0)",
      position: "absolute"
    }
  });

  return React.createElement(S.Slider, Object.assign({}, n), React.createElement(S.ControlsContainer, null, React.createElement(S.TeaserContainer, null, React.createElement(S.TeaserWrapper, null, React.createElement(TransitionContainer, null, c(function (e, t) {
    var n = r[getPreviousIndex(getPreviousIndex(t, a), a)];
    return "object" == typeof n.image ? React.createElement(S.TeaserComponent, {
      style: e,
      alt: n.imageAlt
    }, n.image) : React.createElement(S.Teaser, {
      style: e,
      alt: n.imageAlt,
      src: n.image
    });
  }))), React.createElement(S.TeaserWrapper, null, React.createElement(TransitionContainer, null, m(function (e, t) {
    var n = r[getPreviousIndex(t, a)];
    return "object" == typeof n.image ? React.createElement(S.TeaserComponent, {
      style: e,
      alt: n.imageAlt
    }, n.image) : React.createElement(S.Teaser, {
      style: e,
      alt: n.imageAlt,
      src: n.image
    });
  })))), r[i].eyebrow ? React.createElement(S.EyebrowMobile, null, r[i].eyebrow) : null, React.createElement(S.SliderTitle, null, t), React.createElement(LeftControl, {
    onClick: function onClick() {
      return o(getPreviousIndex(i, a)), void s("right");
    }
  }), React.createElement(RightControl, {
    onClick: function onClick() {
      return o(getNextIndex(i, a)), void s("left");
    }
  })), React.createElement(S.SlideContainer, null, React.createElement(Slide, Object.assign({
    direction: l,
    activeSlide: i
  }, r[i]))), React.createElement(S.Chips, {
    count: a,
    activeChip: i
  }));
}
export default SliderContainer;